import React, { useContext } from "react";
import axiosHelper from "../../../helpers/axios-helper";
import "../../../styles/pages/login.css";
import { toast } from "react-toastify";
import WebSignupForm from "./WebSignupForm";
import { CurrentPlayerContext } from "../../../contexts/CurrentPlayerContext";
import { useNavigate } from "react-router-dom";
import config from "../../../helpers/config";

export default function WebSignup() {
  const { player, changeCurrentPlayer } = useContext(CurrentPlayerContext);
  const nav = useNavigate();

  const savePlayer = (rctoken, data, resetCaptcha) => {
    axiosHelper
      .post("/playerweb/signupwc?rctoken=" + rctoken, data)
      .then((response) => {

        toast.success("Kayıt başarılı. İsterseniz bu sayfadan bilgilerinizi güncelleyebilirsiniz." );
        changeCurrentPlayer(response.data);
        nav("/player/account");


        // toast.success(
        //   "Kayıt başarılı. Oyuna yönlendiriliyorsunuz. Lütfen bekleyiniz..."
        // );
        // console.log(response);
        // setTimeout(() => {
        //   window.location.href = config.gameUrl + "?p=" + response.data;
        // }, 2000);
      })
      .catch((error) => {
        resetCaptcha();
        axiosHelper.handleError(error, "Signup failed");
      });
  };

  return <WebSignupForm savePlayer={savePlayer} />;
}
